import React from 'react';
import PropTypes from 'prop-types';
import './LookbookReportStats.scss';
import _ from 'lodash';
import { getPrettyNumber } from '../../../../Helpers/formatting';
import Loader from '../../../Loader/Loader';
import { getLookbookRequests } from '../../../../Helpers/lookbook_helpers';

const LookbookReportStats = props => {
  const { lookbook, analytics, pins, mentionUserStats, isFetchingPins } = props;
  const lookbookRequests = getLookbookRequests(analytics, lookbook);
  const requests = lookbookRequests;

  const totalRequestCount = requests.length;
  const requestsAcceptedCount = requests.filter(request => request.userAccepted).length;
  const requestsPromotedCount = requests.filter(request => request.userPromoted).length;
  const promotedPercentage = requestsAcceptedCount ? Math.round((requestsPromotedCount / requestsAcceptedCount) * 100).toFixed() : 0;

  const clicks = _.sumBy(pins, 'views');
  const volume = _.sumBy(pins, 'orderVolumeTotal');

  const views = _.sumBy(mentionUserStats, 'views');
  const estimatedEmv = _.sumBy(pins, 'estimatedMediaValue');

  return (
    <div className='lookbook-report-stats-outer'>
      <div className='lookbook-report-section-title' id='overall-statistics'>
        Overall Statistics
      </div>

      <div className='lookbook-report-stats-inner'>
        <div className='stat-container'>
          <div className='stat-value'>{totalRequestCount ? getPrettyNumber(totalRequestCount || 0, { precision: 0 }) : '-'}</div>
          <div className='stat-title'>Invited</div>
        </div>

        <div className='stat-container less-important'>
          <div className='stat-value'>{promotedPercentage ? `${promotedPercentage}%` : '-'}</div>
          <div className='stat-title'>% Promoted</div>
        </div>

        <div className='stat-container'>
          <div className='stat-value'>{!isFetchingPins ? getPrettyNumber(clicks, { precision: 0 }) || '-' : <Loader size={20} />}</div>
          <div className='stat-title'>Clicks</div>
        </div>

        <div className='stat-container'>
          <div className='stat-value'>
            {!isFetchingPins ? volume ? `$${getPrettyNumber(volume || 0, { precision: 0 })}` : '-' : <Loader size={20} />}
          </div>
          <div className='stat-title'>Volume</div>
        </div>

        <div className='stat-container'>
          <div className='stat-value'>{!isFetchingPins ? getPrettyNumber(views, { precision: 0 }) || '-' : <Loader size={20} />}</div>
          <div className='stat-title'>Views</div>
        </div>

        <div className='stat-container'>
          <div className='stat-value'>
            {!isFetchingPins ? estimatedEmv ? `$${getPrettyNumber(estimatedEmv, { precision: 0 })}` : '-' : <Loader size={20} />}
          </div>
          <div className='stat-title'>EMV</div>
        </div>
      </div>
    </div>
  );
};

LookbookReportStats.propTypes = {
  mentionUserStats: PropTypes.array.isRequired,
  pins: PropTypes.array.isRequired,
  analytics: PropTypes.object.isRequired,
  lookbook: PropTypes.object.isRequired,

  isFetchingPins: PropTypes.bool.isRequired
};

export default LookbookReportStats;
